import _ from 'lodash';
import { dynamicSort } from '../../../../common/utilities/sort';

export const downloadContentInFile = (fileName, extension = 'txt', content = '') => {
    const url = window.URL.createObjectURL(new Blob([content]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `${fileName}.${extension}`); // or any other extension
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};

export const handleSort = (filteredData, setFilteredData, dataKey, sortType) => {
    let sortedFilteredData = [];
    const dynamicSortOrder = sortType === 'desc' ? '-' : '';

    switch (dataKey) {
        case 'name':
            sortedFilteredData = filteredData.sort(
                dynamicSort(`${dynamicSortOrder}name`),
            );
            break;
        case 'description':
            sortedFilteredData = filteredData.sort(
                dynamicSort(`${dynamicSortOrder}description`),
            );
            break;
        case 'currentStatus':
            sortedFilteredData = filteredData.sort(
                dynamicSort(`${dynamicSortOrder}currentStatus.label`),
            );
            break;
        case 'currentStatusEffectiveDate':
            sortedFilteredData = filteredData.sort(
                dynamicSort(`${dynamicSortOrder}currentStatus.effectiveDateEpoch`),
            );
            break;
        default:
            break;
    }
    setFilteredData(_.cloneDeep(sortedFilteredData));
};

export const searchableAudit = (audit) => `${audit.name}
        |${audit.description}
        |${audit.currentStatus.label}
        `.toLocaleLowerCase();
